import type { LoadBalancingWorkerSkillsQueryCgResponse } from '@common/graphql';

export type WorkerSkillType = Pick<
  NonNullable<
    LoadBalancingWorkerSkillsQueryCgResponse['loadBalancingWorker']['skills']
  >[number],
  'id' | 'name'
>;

export function sortSkillsByName<T extends WorkerSkillType>(
  skills: readonly T[]
): T[] {
  return [...skills].sort((a, b) => a.name.localeCompare(b.name));
}

export function uniqueSkills(
  skills: readonly WorkerSkillType[]
): WorkerSkillType[] {
  const byId = new Map(skills.map((skill) => [skill.id, skill]));

  return sortSkillsByName([...byId.values()]);
}
